import React from 'react'
import Link from 'gatsby-link'
import Helmet from 'react-helmet'
import Img from "gatsby-image"
import config from "../../data/SiteConfig"
import SEO from '../components/SEO/SEO'
import ProjectListing from '../components/ProjectListing/ProjectListing'

export default class Index extends React.Component {
	render() {
		const projectEdges = this.props.data.projects.edges
		return (
			<div className="projects-container">
				<Helmet>
					<title>المشاريع - {config.siteTitle}</title>
				</Helmet>
				<div>
					<ProjectListing projectEdges={projectEdges} />
				</div>
			</div>
		)
	}
}

export const pageQuery = graphql`
  query projectsQuery {
    projects: allMarkdownRemark(
    sort: { fields: [frontmatter___id], order: DESC }
    filter: { fields: { sourceInstanceName: { eq: "projects" } } }
    ) {
      edges {
        node {
          fields {
            slug
            sourceInstanceName
          }
          frontmatter {
            title
            service
            client
            date
            coverImage {
              childImageSharp {
                sizes(
                  maxWidth: 450
                  quality: 90
                  traceSVG: { color: "#f3f3f3" }
                ) {
                  ...GatsbyImageSharpSizes_withWebp_noBase64
                }
              }
            }
          }
        }
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/pages/projects.jsx